<section class="about-section py-5" id="about">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 mx-auto text-center mb-5">
        <h2 class="section-title">{{ i18n.getTranslation('about.title') }}</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 mb-4 mb-lg-0">
        <div class="about-image">
          <img src="assets/images/profile.jpg" alt="Profile" class="img-fluid rounded-circle shadow-lg">
        </div>

        <!-- Statistics -->
        <div class="row text-center mt-5">
          <div class="col-4">
            <div class="stat-item">
              <h3 class="stat-number">{{ stats.experience }}+</h3>
              <p class="stat-label">{{ i18n.getTranslation('about.experience') }}</p>
            </div>
          </div>
          <div class="col-4">
            <div class="stat-item">
              <h3 class="stat-number">{{ stats.projects }}+</h3>
              <p class="stat-label">{{ i18n.getTranslation('about.projects') }}</p>
            </div>
          </div>
          <div class="col-4">
            <div class="stat-item">
              <h3 class="stat-number">{{ stats.clients }}+</h3>
              <p class="stat-label">{{ i18n.getTranslation('about.clients') }}</p>
            </div>
          </div>
        </div>

        <!-- Skills highlight -->
        <div class="skills-highlight mt-5">
          <h5 class="mb-3">{{ i18n.getTranslation('about.coreTechnologies') }}:</h5>
          <div class="tech-badges">
            <span class="badge tech-badge me-2 mb-2" *ngFor="let tech of coreTechnologies">
              {{ tech }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="about-content">
          <p class="lead mb-4">{{ i18n.getTranslation('about.description') }}</p>
          <p class="lead mb-4">{{ i18n.getTranslation('about.description2') }}</p>
          <p class="lead mb-4">{{ i18n.getTranslation('about.description3') }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
